"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGlobal = void 0;
var isStr_1 = __importDefault(require("licia/isStr"));
var copy_1 = __importDefault(require("licia/copy"));
var toArr_1 = __importDefault(require("licia/toArr"));
var keys_1 = __importDefault(require("licia/keys"));
var xpath_1 = __importDefault(require("licia/xpath"));
var each_1 = __importDefault(require("licia/each"));
var global = {
    copy: function (value) {
        if (!isStr_1.default(value))
            value = JSON.stringify(value, null, 2);
        copy_1.default(value);
    },
    $: function (selector) {
        return document.querySelector(selector);
    },
    $$: function (selector) {
        return toArr_1.default(document.querySelectorAll(selector));
    },
    $x: function (path) {
        return xpath_1.default(path);
    },
    keys: keys_1.default,
};
function injectGlobal() {
    each_1.default(global, function (val, name) {
        if (window[name])
            return;
        window[name] = val;
    });
}
function clearGlobal() {
    each_1.default(global, function (val, name) {
        if (window[name] && window[name] === val) {
            delete window[name];
        }
    });
}
function setGlobal(name, val) {
    global[name] = val;
}
exports.setGlobal = setGlobal;
function evaluate(expression) {
    var ret;
    injectGlobal();
    try {
        ret = eval.call(window, "(" + expression + ")");
    }
    catch (e) {
        ret = eval.call(window, expression);
    }
    clearGlobal();
    return ret;
}
exports.default = evaluate;
